<div class="twin-modal">
  <div class="add-account-signature">
    <!-- Close Button at Top -->
    <div class="close-button-container">
      <button type="button" class="close-button" (click)="close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <!-- Modal Header -->
    <div class="modal-header-section">
      @if (mode == 'add') {
        <h2 class="modal-title">Add Signature</h2>
      }
      @if (mode == 'edit') {
        <h2 class="modal-title">Edit Signature</h2>
      }
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <form [formGroup]="uploadSignatureForm" class="clrsgn-form">
        <!-- Account Signature Dropdown (for commission mode) -->
        @if (commission && signatures && signatures.length > 0) {
          <div class="form-section signature-name">
            <mat-form-field class="form-group" subscriptSizing="dynamic">
              <mat-label for="accountSignature" class="clrsgn-label">Account Signature:</mat-label>
              <mat-select formControlName="accountSignature"
                id="accountSignatures"
                data-cy="accountSignatureDropdownList"
                [multiple]="false">
                @if (signatures) {
                  <mat-option [value]="{}">-- Select a signature --</mat-option>
                }
                @for (signature of signatures; track signature) {
                  <mat-option
                    [value]="signature">
                    {{ signature?.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        <!-- File Upload Section (always visible) -->
        <div class="upload-section">
          <div class="upload-drop-zone"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="triggerFileInput()">
            <div class="upload-icon">
              <img src="assets/icons/file_upload.svg" alt="Upload file" width="24" height="24">
            </div>

            <div class="upload-content">
              <p class="upload-text">
                Drag and drop, or
                <button type="button" class="browse-link" (click)="triggerFileInput($event)">browse files</button>
              </p>
            </div>

            <input type="file"
              #fileInput
              class="file-input-hidden"
              [accept]="getAcceptedFileTypes()"
              (change)="onFileSelected($event)">
            </div>

            <!-- File format text underneath the upload box -->
            <p class="file-formats">Accepted formats: {{ supportedFormatsText }} • Max file size: {{ maxFileSizeText }}</p>

            <app-form-error [group]="uploadSignatureForm"
              [controlName]="'signature'"
            [customErrorMessage]="allowedFileTypesMessage"></app-form-error>
          </div>

          <!-- Default messaging when unable to detect data matrix -->
          @if (isDataMatrixCheckPassed === false && isProcessing === false) {
          <div class="modal-signature-invalid-message">
            <img
              ngSrc="assets/icons/orange-warning-icon.svg"
              alt="Orange Warning Icon"
              height="24"
              width="24"
            />
            <div>
              <h5>
                We couldn't detect a signature on the document you uploaded.
              </h5>
              <p>
                If you didn't use the provided template, please fill out the
                template and upload that version instead.<br />
                If you did use the template, try scanning it again to ensure the
                signature is clear and easy to read.
              </p>
            </div>
          </div>
          }

          <!-- Signature Name Field (above preview) -->
          @if (isDataMatrixCheckPassed === true && !commission && ((signatureUploaded | async) || hasSignature)) {
            <div class="form-section">
              <mat-form-field appearance="fill" subscriptSizing="dynamic">
                <mat-label for="name" class="clrsgn-label">
                  Signature Name:
                </mat-label>
                <input matInput
                  maxlength="128"
                  type="text"
                  formControlName="name"
                  id="name">
                </mat-form-field>
              </div>
            }

          <!-- Signature Preview Section (appears underneath after upload) -->
          @if (isDataMatrixCheckPassed === true && isProcessing === false &&(signatureUploaded | async) || hasSignature) {
            <div class="preview-section">
              <h4 class="preview-title">Signature Preview</h4>
              <div class="signature-preview-container">
                <img [src]="getSanitizedImage(selectedSignatureBase64)"
                  class="signature-preview-image"
                  alt="Signature preview"/>
                </div>
                <p class="replace-text">
                  Not the right signature? Drag in a new file or select one using
                  'browse files' to replace it.
                </p>
                <!-- Validation Messages inside preview section -->

          @if(isSignatureValid === false && (signatureUploaded | async) && (isSignatureDetectionIntelligenceEnabledStream$ |
          async)) {
          <div class="modal-signature-invalid-message">
            <img ngSrc="assets/icons/orange-warning-icon.svg" alt="Orange Warning Icon" height="24" width="24">
            <p>We couldn't confidently verify your signature. Please make sure you uploaded the correct file. If you believe
              this is a mistake, you can still continue.</p>
          </div>
          }

                @if(isSignatureValid === true && (signatureUploaded | async) && (isSignatureDetectionIntelligenceEnabledStream$ |
                  async)) {
                  <div class="modal-signature-valid-message">
                    <img ngSrc="assets/icons/green_check_with_circle_icon.svg" alt="Green Successful Icon" height="24" width="24">
                    <p>Your signature has been successfully verified. Everything looks good—you're all set to save your new
                    signature!</p>
                  </div>
                }
                <!-- Buttons directly under preview -->
                <div class="button-container">
                  <button type="button" class="btn-secondary" (click)="close()">Cancel</button>
                  @if (isSignatureDetectionIntelligenceEnabledStream$ | async) {
                    <button type="button"
                      class="btn-primary"
                      (click)="saveSignature()"


                    [disabled]="(isDataMatrixCheckPassed === false) || !(isSignatureSelectedFromFormField || (isSignatureValid !== undefined && (signatureUploaded | async))) || isSignatureDetectionLoading">
                      {{ mode === 'add' ? 'Add Signature' : 'Save' }}
                    </button>
                  }
                  @if ((isSignatureDetectionIntelligenceEnabledStream$ | async) === false) {
                    <button type="button"
                      class="btn-primary"
                      (click)="saveSignature()"
                      >
                      {{ mode === 'add' ? 'Add Signature' : 'Save' }}
                    </button>
                  }
                </div>
              </div>
            }

              <!-- Buttons below upload form when no signature uploaded -->
              @if (isDataMatrixCheckPassed === false || !((signatureUploaded | async) || hasSignature)) {
                <div class="button-container">
                  <button type="button" class="btn-secondary" (click)="close()">Cancel</button>
                  <button type="button" class="btn-primary" (click)="saveSignature()" [disabled]="!hasSignature || isDataMatrixCheckPassed === false">Add Signature</button>
                </div>
              }
            </form>
          </div>
        </div>

        <!-- Original Left Panel - Signature Preview Modal (shows after upload) -->
        @if (selectedSignatureBase64 && isSignatureValid && ((signatureUploaded | async) || hasSignature)) {
          <div class="signature-preview-modal">
            <ng-container>
              <div>
                <app-signature-preview [signatureImage]="getSanitizedImage(selectedSignatureBase64)"></app-signature-preview>
              </div>
            </ng-container>
          </div>
        }
      </div>
